query GET_AMENITIES {
  amenities {
    items {
      id
      name
      description
    }
  }
}
